import React from 'react'

const Shimmer = () => {
  return (
    <div className='flex justify-center flex-wrap gap-5'>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
      <div className='w-[295px] h-[345px] bg-gray-800 border-gray rounded-md'></div>
    </div>
  )
}

export default Shimmer
